/**
 * #648 — static map: QUALIFIED Cognito role code (`app:role`, stamped by the
 * account-api PreToken trigger — apps/account-api/src/cognito-triggers/
 * pre-token-generation.js) → its i18n key. Every value is a source LITERAL
 * (see the no-dynamic-i18n-keys convention) so `t()` is never called with a
 * key built from the code itself (no `t(`role.${code}`)`).
 *
 * Source of truth for which roles EXIST is each app's permission manifest
 * (score-common/permissions, account-common/permissions) — this only maps
 * the ones the role switcher displays a label for. Add a new role here AND
 * in locales/en/common.json's `roles` block together.
 */
export const ROLE_LABEL_KEYS = {
  "score:score_scribe": "roles.scoreScribe",
  "score:score_admin": "roles.scoreAdmin",
  "score:score_judge": "roles.scoreJudge",
  "score:score_viewer": "roles.scoreViewer",
  "score:score_announcer": "roles.scoreAnnouncer",
  "account:org_owner": "roles.orgOwner",
  "account:org_admin": "roles.orgAdmin",
};

// A code this map doesn't know yet (a role added to a manifest before this
// map catches up, or a stale/malformed value) degrades to a translated,
// still-readable placeholder rather than the raw code or a crash.
export const UNKNOWN_ROLE_KEY = "roles.unknown";

/**
 * Resolve a qualified role code to its translated display label.
 * @param {Function} t - the i18next translation function (useTranslation("common"))
 * @param {string} role - qualified role code, e.g. "score:score_scribe"
 * @returns {string}
 */
export function roleLabel(t, role) {
  const key = ROLE_LABEL_KEYS[role];
  return key ? t(key) : t(UNKNOWN_ROLE_KEY, { code: role });
}
